module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_CasteloDagua.f5b31d10.jpg";